<template>
    <div>
        <RemoteTable ref="table" :form="form" :table="table" v-show="jobId < 1">
            <template #expand="{row}">
                <el-form label-position="left" class="table-expand">
                    <el-form-item label="短信内容" v-if="row.type.value === 'voice_normal'">{{row.content}}</el-form-item>
                    <el-form-item label="模板内容" v-if="row.type.value === 'voice_template'">{{row.template}}</el-form-item>
                    <el-form-item label="创建时间">{{row.createTime}}</el-form-item>
                </el-form>
            </template>
            <template #default="{row, property}">
                <template v-if="property === 'id'">
                    {{getId(row.id)}}
                </template>
                <template v-else-if="property === 'code'">
                    {{$root.getBusinessName(row.code)}}
                </template>
              <template v-else-if="property === 'type'">
                <template v-if="row.type.value === 'voice_normal'">普通工单</template>
                <template v-if="row.type.value === 'voice_custom'">自定义工单</template>
                <template v-if="row.type.value === 'voice_template'">模板工单</template>
              </template>
            </template>
            <template #tools="{row}" v-if="!$root.isOperation">
                <el-tooltip content="审核通过" placement="top" v-if="row.status.value === 'submit'">
                    <el-button type="text" icon="el-icon-check" size="small" @click="toCheck(row)"></el-button>
                </el-tooltip>
                <el-tooltip content="取消" placement="top" v-else-if="row.status.value === 'pending'">
                    <el-button type="text" icon="el-icon-switch-button" size="small" @click="toCancel(row)"></el-button>
                </el-tooltip>
                <el-tooltip content="预览" placement="top">
                    <el-button type="text" icon="el-icon-view" size="small" @click="toPreview(row)"></el-button>
                </el-tooltip>
                <el-tooltip content="删除" placement="top"
                            v-if="row.status.value !== 'sending' && row.status.value !== 'finished'">
                    <el-button type="text" icon="el-icon-delete" size="small" @click="toDel(row)"></el-button>
                </el-tooltip>
            </template>
        </RemoteTable>
        <el-dialog title="工单预览" :visible.sync="preview.visible">
            <el-table :data="preview.data">
                <el-table-column property="mobile" label="手机号" width="150"></el-table-column>
                <el-table-column property="content" label="内容"></el-table-column>
            </el-table>
        </el-dialog>
        <JobDetail :jobId="jobId" @close="jobId = 0" v-if="jobId > 0"></JobDetail>
    </div>
</template>

<script>
    import RemoteTable from '@/components/RemoteTable'
    import JobDetail from '../page/JobDetail'

    export default {
        components: {
            JobDetail,
            RemoteTable
        },
        data() {
            return {
                jobId: 0,
                form: {
                    configs: [
                        {name: "code", label: "业务", type: "cascade", op: "beginwith", value: ""},
                        {name: "id", label: "编号", type: "input", value: ""},
                        {name: "name", label: "名称", type: "input", op: "contains", value: ""},
                        {name: "planTime", label: "执行时间", type: "datetimerange", op: "between", value: []},
                        {name: "status", label: "状态", type: "select", url: "/dict/list/job/status", value: ""},
                        {name: "type", type: "hidden", op: "in", value: ['voice_normal', 'voice_custom', 'voice_template']},
                    ],
                    tools: [
                        {
                            icon: "el-icon-plus", click: () => {
                                this.$router.push("/voice/job/0")
                            }
                        },
                      this.$root.couldExport ? {
                            label: "导出", click: () => {
                                let queryInfo = this.$refs.table.getQueryInfo();
                                delete queryInfo['limit'];
                                delete queryInfo['offset'];

                                this.$confirm('请选择要下载的内容?', '提示', {
                                  distinguishCancelAndClose: true,
                                    confirmButtonText: '工单列表',
                                    cancelButtonText: '工单明细',
                                    type: 'warning'
                                }).then(() => {
                                    this.$axios.post("/job/downloadList", queryInfo).then((response) => {
                                        this.$utils.download("/file/pop/" + response);
                                    })
                                }).catch((action) => {
                                  if (action === 'close') {
                                    return;
                                  }
                                    this.$axios.post("/job/batchDownload", queryInfo).then((response) => {
                                        if (response.success) {
                                            this.$message(response['message']);
                                        } else {
                                            this.$message.error(response['message']);
                                        }
                                    })
                                });
                            }
                        } : {}
                    ]
                },
                table: {
                    urlPrefix: "/job",
                    expand: true,
                    defaultSort: {prop: 'createTime', order: 'descending'},
                    columns: [
                        {label: "工单编号", name: "id", width: 90},
                        {label: "业务名称", name: "code"},
                        {label: "工单名称", name: "name", width: 200},
                        {label: "工单类型", name: "type", width: 100},
                        {label: "手机号码数", name: "totalNum", width: 120},
                        {label: "预计费数", name: "totalCount", width: 80},
                        {label: "错误数", name: "errorNum", width: 80},
                        {label: "重复号码数", name: "duplicateNum", width: 120},
                        {label: "执行时间", name: "planTime", width: 150},
                        {label: "状态", name: "status", width: 80},
                        {label: "操作", name: "tool", width: 100},
                    ],
                    primaryColumns: [
                        {
                            name: "name",
                            method: (row) => {
                                this.jobId = row.id;
                            }
                        }
                    ]
                },
                preview: {
                    visible: false,
                    data: [],
                }
            }
        },
        methods: {
            getId(id) {
                let code = id + "";
                const len = 7 - code.length;
                for (let i = 0; i < len; i++) {
                    code = "0" +code;
                }
                return "J" + code.split('').reverse().join('');
            },
            toCheck(row) {
                this.$axios.get('/job/beforeaudit/' + row.id).then((response) => {
                    let balance = response.data.balance;
                    let pendingCount = response.data.pendingCount;
                    let count = response.data.count;

                    let val = balance - pendingCount;
                    if (val < count) {
                        this.$message.error("余额已不足！");
                        return;
                    }
                    if (val - count < 1000) {
                        this.$confirm("剩余余额：" + val + "，本次工单消耗余额：" + count +"，是否继续？", "提示", {
                            confirmButtonText: "继续",
                            cancelButtonText: "取消",
                            type: 'warning'
                        }).then(() => {
                            this.$axios.post('/job/edit', {
                                id: row.id,
                                status: {value: "pending"}
                            }).then((response) => {
                                if (response.success) {
                                    this.$message.success("审核成功！");
                                } else {
                                    this.$message.error(response.message);
                                }
                                this.$refs.table.load();
                            })
                        });
                    } else {
                        this.$confirm("是否确定工单通过审核？", "提示", {
                            confirmButtonText: "确定",
                            cancelButtonText: "取消",
                            type: 'warning'
                        }).then(() => {
                            this.$axios.post('/job/edit', {
                                id: row.id,
                                status: {value: "pending"}
                            }).then((response) => {
                                if (response.success) {
                                    this.$message.success("审核成功！");
                                } else {
                                    this.$message.error(response.message);
                                }
                                this.$refs.table.load();
                            })
                        });
                    }
                });
            },
            toCancel(row) {
                this.$confirm("是否取消工单？", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: 'warning'
                }).then(() => {
                    this.$axios.post('/job/edit', {
                        id: row.id,
                        status: {value: "cancelled"}
                    }).then((response) => {
                        if (response.success) {
                            this.$message.success("取消成功！");
                        } else {
                            this.$message.error(response.message);
                        }
                        this.$refs.table.load();
                    })
                });
            },
            toDel(row) {
                this.$confirm("是否进行删除操作？", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: 'warning'
                }).then(() => {
                    this.$axios.get('/job/remove/' + row.id).then((response) => {
                        if (response.success) {
                            this.$message.success("删除成功！");
                            this.$refs.table.load();
                        } else {
                            this.$message.error(response.message);
                        }
                    })
                });
            },
            toPreview(row) {
                this.preview.data = [];
                this.preview.visible = true;

                this.$axios.post('/jobsample/list', {
                    rules: [
                        {field: "jobId", value: row['id']}
                    ]
                }).then((response) => {
                    this.preview.data = response;
                })
            },
        }
    }
</script>